import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import { IconContainer, NavLink, TextContainer } from './style'

const NavigationLink = ({ link }) => (
  <NavLink
    role="presentation"
    key={link.href}
    icon={link.icon}
    onClick={link?.onClick}
    style={{ display: 'flex', alignItems: 'center' }}
  >
    {link.icon && (
      <IconContainer>
        {typeof link.icon === 'string' ? (
          <img src={link.icon} alt="nav-link-icon" />
        ) : (
          link.icon
        )}
      </IconContainer>
    )}

    <Link to={link.href} disabled={link.disabled}>
      <TextContainer>{link.text}</TextContainer>
    </Link>
  </NavLink>
)

NavigationLink.propTypes = {
  link: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }).isRequired,
}

export default memo(NavigationLink)
